import moment from 'moment';
import mergeWith from 'lodash/mergeWith';
import isFinite from 'lodash/isFinite';
import orderBy from 'lodash/orderBy';
import groupBy from 'lodash/groupBy';
import sortedUniqBy from 'lodash/sortedUniqBy';
import find from 'lodash/find';
import isUndefined from 'lodash/isUndefined';
import first from 'lodash/first';
import last from 'lodash/last';

export const tableInitialState = {
	columns: {
		hosts: {
			id: 'hosts',
			direction: 'desc',
			title: 'Хосты',
			parent: 'traffic',
			isShow: true,
			conditionIndex: 1
		},
		hits: {
			id: 'hits',
			direction: 'desc',
			title: 'Хиты',
			parent: 'traffic',
			isShow: true,
			conditionIndex: 2
		},
		transitions: {
			id: 'transitions',
			direction: 'desc',
			title: 'Переходы',
			parent: 'traffic',
			isShow: true
		},
		accepted_conversions: {
			id: 'accepted_conversions',
			direction: 'desc',
			title: 'Подтверждено',
			parent: 'conversions',
			isShow: true,
			conditionIndex: 3
		},
		pending_conversions: {
			id: 'pending_conversions',
			direction: 'desc',
			title: 'Ожидает',
			parent: 'conversions',
			isShow: true,
			conditionIndex: 4
		},
		declined_conversions: {
			id: 'declined_conversions',
			direction: 'desc',
			title: 'Отклонено',
			parent: 'conversions',
			isShow: true,
			conditionIndex: 5
		},
		total_conversions: {
			id: 'total_conversions',
			direction: 'desc',
			title: 'Всего',
			parent: 'conversions',
			isShow: true,
			conditionIndex: 6
		},
		invalid_conversions: {
			id: 'invalid_conversions',
			direction: 'desc',
			title: 'Невалидные',
			parent: 'conversions',
			isShow: true,
			conditionIndex: 7
		},
		epc: {
			id: 'epc',
			direction: 'desc',
			title: 'EPC',
			parent: 'coefficients',
			isShow: true,
			conditionIndex: 8
		},
		crs: {
			id: 'crs',
			direction: 'desc',
			title: 'CRS',
			parent: 'coefficients',
			isShow: true,
			conditionIndex: 9
		},
		crl: {
			id: 'crl',
			direction: 'desc',
			title: 'CTR',
			parent: 'coefficients',
			isShow: true,
			conditionIndex: 10
		},
		approve: {
			id: 'approve',
			direction: 'desc',
			title: 'Approve',
			parent: 'coefficients',
			isShow: true,
			conditionIndex: 11
		},
		accepted_income: {
			id: 'accepted_income',
			direction: 'desc',
			title: 'Подтверждено',
			parent: 'revenue',
			isShow: true,
			conditionIndex: 12
		},
		pending_income: {
			id: 'pending_income',
			direction: 'desc',
			title: 'Ожидает',
			parent: 'revenue',
			isShow: true,
			conditionIndex: 13
		},
		declined_income: {
			id: 'declined_income',
			direction: 'desc',
			title: 'Отклонено',
			parent: 'revenue',
			isShow: true,
			conditionIndex: 14
		},
		bonus: {
			id: 'bonus',
			direction: 'desc',
			title: 'Бонус',
			parent: 'revenue',
			isShow: false,
			conditionIndex: 1
		}
	},
	groupColumns: {
		date: {
			id: 'date',
			title: 'Дата',
			direction: 'desc'
		},
		hour: {
			id: 'hour',
			title: 'Часы',
			direction: 'desc'
		},
		dow: {
			id: 'dow',
			title: 'День недели',
			direction: 'desc'
		},
		status_changed_at: {
			id: 'status_changed_at',
			relationToFilter: 'status_changed_at',
			title: 'Дата изменения статуса',
			direction: 'desc'
		},
		session: {
			id: 'session',
			relationToFilter: 'session_ids',
			title: 'ID сплит сессии',
			direction: 'desc'
		},
		month: {
			id: 'month',
			index: 'month',
			title: 'Месяц',
			direction: 'desc'
		},
		offer: {
			id: 'offer',
			title: 'Оффер',
			direction: 'asc',
			relationToFilter: 'offers'
		},
		campaign: {
			id: 'campaign',
			title: 'Поток',
			direction: 'asc',
			relationToFilter: 'campaigns'
		},
		campaign_type: {
			id: 'campaign_type',
			title: 'Тип потока',
			direction: 'asc',
			relationToFilter: 'campaign_types'
		},
		traffic_source: {
			id: 'traffic_source',
			title: 'Источник трафика',
			direction: 'asc',
			relationToFilter: 'traffic_source'
		},
		landing: {
			id: 'landing',
			title: 'Лендинг',
			direction: 'asc',
			relationToFilter: 'landings'
		},
		transit: {
			id: 'transit',
			title: 'Транзитная страница',
			direction: 'asc',
			relationToFilter: 'transits'
		},
		country: {
			id: 'country',
			title: 'Страна',
			direction: 'asc',
			relationToFilter: 'countries'
		},
		city: {
			id: 'city',
			title: 'Город',
			direction: 'asc',
			relationToFilter: 'cities'
		},
		traffic_type: {
			id: 'traffic_type',
			title: 'Тип траффика',
			direction: 'asc',
			relationToFilter: 'traffic_types'
		},
		sid1: {
			id: 'sid1',
			title: 'SID 1',
			direction: 'asc',
			relationToFilter: 'sids1'
		},
		sid2: {
			id: 'sid2',
			title: 'SID 2',
			direction: 'asc',
			relationToFilter: 'sids2'
		},
		sid3: {
			id: 'sid3',
			title: 'SID 3',
			direction: 'asc',
			relationToFilter: 'sids3'
		},
		sid4: {
			id: 'sid4',
			title: 'SID 4',
			direction: 'asc',
			relationToFilter: 'sids4'
		},
		sid5: {
			id: 'sid5',
			title: 'SID 5',
			direction: 'asc',
			relationToFilter: 'sids5'
		},
		sale_model: {
			id: 'sale_model',
			title: 'Модель продаж',
			direction: 'asc',
			relationToFilter: 'sale_model'
		}
	},
	sortByColumn: null,
	sortByGroup: {
		date: {
			id: 'date',
			direction: 'desc'
		},
		dow: {
			id: 'dow',
			direction: 'asc'
		},
		hour: {
			id: 'hour',
			direction: 'asc'
		}
	}
};

export const transformRows = (rows, groups, sortByColumn, sortByGroup, columnControl, userLang) => {
	const transformed = transformDow(rows, groups, userLang);
	const calculated = calculateCoefficientColumns(transformed);
	const filteredByColumnControl = filterByColumnControl(calculated, columnControl);
	const withTotal = calculateTotalRow(filteredByColumnControl, groups);
	return groupRows(withTotal, groups, sortByColumn, sortByGroup);
};

const transformDow = (rows, groups, lang) => {
	if (lang === 'en' || !groups || !find(groups, { id: 'dow' })) {
		return rows;
	}

	return rows
		.map(row => ({ ...row, dow: row.dow - 1 }))
		.map(row => {
			if (row.dow === -1) {
				return {
					...row,
					dow: 6 // sunday in non-en variants
				};
			}
			return row;
		});
};

const groupRows = (rows, groups, sortByColumn, sortByGroup) => {
	if (!rows || !rows.length) {
		return [];
	}

	let result = new Map();
	let totalRow = rows.pop();

	let firstGroupSorting = groups[0] && (sortByGroup[groups[0].id] || groups[0]);
	let secondGroupSorting = groups[1] && (sortByGroup[groups[1].id] || groups[1]);

	let sorted = groups[1]
		? sortColumns(rows, firstGroupSorting)
		: sortColumns(sortColumns(rows, firstGroupSorting), sortByColumn);
	let grouped = groupBy(sorted, groups[0].id);
	let keys = getKeys(sorted, groups[0].id);

	if (secondGroupSorting) {
		keys.forEach(key => {
			grouped[key] = sortColumns(sortColumns(grouped[key], secondGroupSorting), sortByColumn);
		});
	}

	keys.forEach(key => result.set(key, groups[1] ? calculateTotalRow(grouped[key], groups) : grouped[key]));
	!groups[1] && result.set('total', [totalRow]);

	return result;
};

const getKeys = (sortedRows, groupKey) => {
	if (!sortedRows) return null;
	return sortedUniqBy(sortedRows, row => row[groupKey]).map(row => row[groupKey]);
};

const calculateCoefficientColumns = rows => rows.map(calculate);

const sortColumns = (rows, sortByColumn) => {
	if (!rows) return null;
	if (!sortByColumn) return rows;
	return orderBy(
		rows,
		row => {
			const value = row[sortByColumn.id];
			switch (sortByColumn.id) {
				case 'total_conversions':
				case 'invalid_conversions':
				case 'accepted_conversions':
				case 'pending_conversions':
				case 'declined_conversions':
				case 'hits':
				case 'hosts':
				case 'transitions':
				case 'epc':
				case 'crs':
				case 'crl':
				case 'approve':
				case 'accepted_income':
				case 'pending_income':
				case 'declined_income':
				case 'bonus':
					return parseFloat(value);
				default:
					return value;
			}
		},
		sortByColumn.direction
	);
};

const calculateTotalRow = (rows, groups) => {
	if (!rows.length) return [];

	if (rows.length === 1) {
		rows.push({
			...rows[0],
			isTotal: true,
			dateRange: groups.length === 2 ? formatDateRange(rows[0].date, rows[0].date) : null
		});
		return rows;
	}

	const total = rows.reduce((prevRow, curRow) =>
		mergeWith(
			{ ...prevRow }, { ...curRow },
			(prevValue, curValue) => (parseFloat(prevValue) || 0) + (parseFloat(curValue) || 0))
	);

	if (groups.length === 2) {
		let firstGroup = groups[0].id;
		total[firstGroup] = rows[0][firstGroup];
	}

	rows.push(
		calculate({
			...total,
			isTotal: true,
			dateRange: groups.length === 2 ? formatDateRange(first(rows).date, last(rows).date) : null
		})
	);

	return rows;
};

const formatDateRange = (dateStart, dateEnd) => {
	let dateRange;
	let orderedDates = orderBy([dateStart, dateEnd], val => val, 'asc');
	const formattedDateStart = moment(orderedDates[0]).isValid() && moment(orderedDates[0]).format('YYYY-MM-DD');
	const formattedDateEnd = moment(orderedDates[1]).isValid() && moment(orderedDates[1]).format('YYYY-MM-DD');

	if (formattedDateStart && formattedDateEnd) {
		let updatedDateStart = moment(formattedDateStart).hours(0).minutes(0).seconds(0).milliseconds(0);
		let updatedDateEnd = moment(formattedDateEnd).hours(23).minutes(59).seconds(59).milliseconds(999);

		dateRange = {
			start: updatedDateStart.format('YYYY-MM-DD HH:mm:ss.SSS'),
			end: updatedDateEnd.format('YYYY-MM-DD HH:mm:ss.SSS')
		};
	}

	return dateRange;
};

const calculate = row => ({
	...row,
	[tableInitialState.columns.epc.id]: epc(row['accepted_income'], row['hosts']),
	[tableInitialState.columns.crl.id]: crl(row['total_conversions'], row['hosts']),
	[tableInitialState.columns.crs.id]: crs(row['accepted_conversions'], row['hosts']),
	[tableInitialState.columns.approve.id]: approve(row['accepted_conversions'], row['total_conversions'])
});

const epc = (acceptedIncome, hosts) => {
	const res = acceptedIncome / hosts;
	return (isFinite(res) && res.toFixed(2)) || 0;
};

const crl = (totalConversions, hosts) => {
	const res = totalConversions / hosts * 100;
	return (isFinite(res) && res.toFixed(2)) || 0;
};

const crs = (acceptedConversions, hosts) => {
	const res = acceptedConversions / hosts * 100;
	return (isFinite(res) && res.toFixed(2)) || 0;
};

const approve = (acceptedConversions, totalConversions) => {
	const res = acceptedConversions / totalConversions * 100;
	return (isFinite(res) && res.toFixed(2)) || 0;
};

const filterByColumnControl = (rows, columnControl) => {
	const columnControlFilters = getColumnControlFilters(columnControl);

	if (columnControlFilters.length) {
		return rows.filter(row => {
			let doInclude = columnControlFilters
				.map(filter => {
					let column = row[filter.columnName];
					return (
						isUndefined(column) ||
						(filter.conditionsType === 'large' && parseInt(column) >= parseInt(filter.conditionsValue)) ||
						(filter.conditionsType === 'less' && parseInt(column) <= parseInt(filter.conditionsValue))
					);
				})
				.filter(filter => !!filter);
			return doInclude.length === columnControlFilters.length;
		});
	}

	return rows;
};

const getColumnControlFilters = columnControl => {
	let columnControlFilters = [];

	if (columnControl) {
		Object.keys(columnControl).forEach(parentColumn => {
			const formData = columnControl[parentColumn]['form'];
			if (formData) {
				Object.keys(formData).forEach(columnName => {
					if (
						!!formData[columnName]['conditionsType'] &&
						!!formData[columnName]['conditionsValue'] &&
						formData[columnName]['isColumnVisible']
					) {
						columnControlFilters.push({
							columnName,
							conditionsType: formData[columnName]['conditionsType'],
							conditionsValue: formData[columnName]['conditionsValue']
						});
					}
				});
			}
		});
	}

	return columnControlFilters;
};



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/statistics/components/table/general/index.js